import { render } from "./BatchMaster.vue?vue&type=template&id=4b7e873a&scoped=true"
import script from "./BatchMaster.vue?vue&type=script&lang=js"
export * from "./BatchMaster.vue?vue&type=script&lang=js"

import "./BatchMaster.vue?vue&type=style&index=0&id=4b7e873a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7e873a"]])

export default __exports__